import { Theme } from '@mui/material/styles';

const cardContainer = {
  '&.MuiPaper-elevation0': {
    '&.MuiCard-root': {
      padding: 0,
      borderRadius: (theme: Theme) => theme.shape.borderRadius * 2,
      overflow: 'hidden',
      width: '244px',
      boxShadow: (theme: Theme) => theme.shadows[3],
    },
    '& .MuiCardHeader-root': {
      display: 'flex',
      padding: '14px 18px 14px 16px',
      alignItems: 'center',
      backgroundColor: (theme: Theme) => theme.palette.background.main,
      borderBottom: (theme: Theme) => theme.borders.main,
    },
    '& .MuiCardHeader-content': {
      display: 'flex',
      flex: 'none',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    '& .MuiCardContent-root': {
      maxHeight: '80vh',
      overflow: 'auto',
    },
    '& .MuiCardContent-root:last-child': {
      padding: '16px 2px 16px 20px',
    },
  },
} as const;

export { cardContainer };
